import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal, Form, Input, Button, Radio, Tabs, InputNumber } from 'antd';
import moment from 'moment-timezone';
import IntlMessage from '../../components/IntlMessage';
import UploadImage from '../../components/Elements/UploadImage';

import { useIntl } from 'react-intl';
import paymentMethodApi from '../../api/paymentMethod';
moment.tz.setDefault('Africa/Dakar');

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

export default function PaymentMethodForm(props) {
  const { onClose, currentData, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const [imgs, setImgs] = useState(null);

  let initialValues = {
    ...currentData,
    status: currentData ? (currentData.status ? 1 : 0) : 1,
  };

  const fileList = useMemo(
    () =>
      currentData && currentData.image
        ? [
            {
              uid: '1',
              name: 'image.png',
              status: 'done ',
              url: currentData.image,
            },
          ]
        : [],
    [currentData]
  );

  const handleSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        let data = { ...values };

        delete data.image;

        const payload = new FormData();
        Object.keys(data).forEach((key) => {
          payload.append(key, data[key]);
        });
        if (imgs) {
          payload.append('image', imgs);
        }

        if (currentData) {
          paymentMethodApi
            .update(currentData.id, payload)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        } else {
          paymentMethodApi
            .create(payload)
            .then(() => {
              setLoading(false);
              handleCancel();
              props.onReload();
            })
            .catch((error) => {
              console.error(error);
              Modal.error({
                title: error.data.message,
                okText: intl.formatMessage({ id: 'global.close' }),
              });
              setLoading(false);
            });
        }
      })
      .catch(() => setLoading(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleCancel = () => {
    //form.resetFields();
    onClose();
  };

  const onChangeImage = (v, f) => {
    setImgs(f);
  };

  const tabItems = [
    {
      key: '1',
      forceRender: true,
      label: <IntlMessage id="global.payment_method" />,
      children: (
        <>
          <Form.Item
            label={<IntlMessage id="global.title" />}
            name="title"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.code" />}
            name="code"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="status" label={<IntlMessage id="global.status" />}>
            <Radio.Group>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.merchant_id" />}
            name="merchant_id"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.secret_key" />}
            name="secret_key"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.service_fee" />}
            name="service_fee"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label={<IntlMessage id="global.cover_image" />}
            name="image"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <UploadImage onChangeData={onChangeImage} initList={fileList} />
          </Form.Item>
        </>
      ),
    },
  ];

  return (
    <Modal
      title={
        currentData ? (
          <IntlMessage id="global.edit" />
        ) : (
          <IntlMessage id="global.add" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="60%"
      onOk={handleSubmit}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessage id="global.cancel" />}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleSubmit}
        >
          {<IntlMessage id="global.save" />}
        </Button>,
      ]}
    >
      <Form
        {...layout}
        form={form}
        initialValues={initialValues}
        labelAlign="left"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Tabs defaultActiveKey="1" items={tabItems}></Tabs>
      </Form>
    </Modal>
  );
}
